import { Divider, Typography } from '@material-ui/core';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import AppTable from '../../../basic/AppTable';
import { useQueryParams } from '../../../../hooks/atoms/query-params-hook';

const statisticsColumns = [
  { id: 1, label: 'Name', field: 'key' },
  { id: 2, label: 'Value', field: 'value' },
];

/*
"name": "Kolmogorov-Smirnov",
"threshold": 0.05,
"p": 2.4672175512418365e-13,
"statistic": 0.03852844643422337,
"status": "FAIL"
 */

const testsColumns = [
  { id: 1, label: 'Name', field: 'name' },
  { id: 2, label: 'p', field: 'p' },
  { id: 3, label: 'Statistic', field: 'statistic' },
  { id: 4, label: 'Status', field: 'status' },
];

const SimulationGroup = (
  {
    group: {
      name,
      hist,
      cdf,
      statistics,
      tests,
    },
  },
) => {
  const statisticsPaginationWithoutCount = useQueryParams();
  const testsPaginationWithoutCount = useQueryParams();

  return (
    <Grid container>
      <Typography variant='h4'>
        {name}
      </Typography>
      <Divider />
      <Grid container item xs={ 12 } spacing={ 3 }>
        <Grid item xs={ 12 } md={ 6 }>
          <Typography variant='body1'>
            Hist
          </Typography>
          <img
            width='100%'
            style={ { maxWidth: '600px' } }
            height='auto'
            alt='hist'
            src={ `data:image/png;charset=utf-8;base64,${ hist }` }
          />
        </Grid>
        <Grid item xs={ 12 } md={ 6 }>
          <Typography variant='body1'>
            CDF
          </Typography>
          <img
            width='100%'
            style={ { maxWidth: '600px' } }
            height='auto'
            alt='cdf'
            src={ `data:image/png;charset=utf-8;base64,${ cdf }` }
          />
        </Grid>
      </Grid>
      <Grid container item xs={ 12 } spacing={ 3 }>
        <Grid item xs={ 12 } md={ 6 }>
          <Grid item xs={ 12 }>
            <Typography variant='h6' style={ { padding: '24px 0' } }>
              Statistics
            </Typography>
          </Grid>
          <Grid item xs={ 12 }>
            <AppTable
              data={ statistics
                ?.slice(statisticsPaginationWithoutCount.page * statisticsPaginationWithoutCount.limit,
                  (statisticsPaginationWithoutCount.page + 1) * statisticsPaginationWithoutCount.limit) }
              columns={ statisticsColumns }
              paginationProps={ {
                ...statisticsPaginationWithoutCount,
                count: statistics.length,
              } }
            />
          </Grid>
        </Grid>
        <Grid item xs={ 12 } md={ 6 }>
          <Grid item xs={ 12 }>
            <Typography variant='h6' style={ { padding: '24px 0' } }>
              Tests
            </Typography>
          </Grid>
          <Grid item xs={ 12 }>
            <AppTable
              data={ tests
                ?.slice(testsPaginationWithoutCount.page * testsPaginationWithoutCount.limit,
                  (testsPaginationWithoutCount.page + 1) * testsPaginationWithoutCount.limit) }
              columns={ testsColumns }
              paginationProps={ {
                ...testsPaginationWithoutCount,
                count: statistics.length,
              } }
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SimulationGroup;
